<template lang="pug">
div
  v-radio-group(v-model="printSelection")
    v-tooltip(top)
      template(v-slot:activator="{ on }")
        span(v-on="on")
          v-radio(label="All Components" :value="PRINT_ALL_COMPONENTS")
      span Export all components of the game.

    v-tooltip(top)
      template(v-slot:activator="{ on }")
        span(v-on="on")
          v-radio(label="Select Components" :value="PRINT_SELECT_COMPONENTS")
      span Select specific components to export.

  v-card.component-selection(v-if="printSelection == PRINT_SELECT_COMPONENTS")
    v-card-text
      v-checkbox(
        v-model="selectedComponents"
        hide-details
        v-for="component in allComponents"
        :key="component.id"
        :label="component.title"
        :value="component.id"
      )
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { PRINT_ALL_COMPONENTS, PRINT_SELECT_COMPONENTS } from '../../store/print'

export default {
  props: ['game'],

  data() {
    return { PRINT_ALL_COMPONENTS, PRINT_SELECT_COMPONENTS }
  },

  computed: {
    ...mapGetters(['findAllGameComponents']),

    allComponents() {
      return this.findAllGameComponents(this.game)
    },

    printSelection: {
      get() {
        return this.game.printSettings.componentSelection
      },
      set(selection) {
        this.updateGame({
          ...this.game,
          printSettings: { ...this.game.printSettings, componentSelection: selection }
        })
      },
    },

    selectedComponents: {
      get() {
        return this.game.printSettings.componentIdsToPrint
      },
      set(components) {
        this.updateGame({
          ...this.game,
          printSettings: { ...this.game.printSettings, componentIdsToPrint: components }
        })
      },
    },
  },

  methods: {
    ...mapActions(['updateGame']),
  },
}
</script>

<style scoped>
.component-selection {
  margin-bottom: 1em;
}

.component-selection .v-card__text {
  padding: .5em;
}

.v-input--checkbox:first-child {
  margin-top: 0;
}
</style>
